import { render, staticRenderFns } from "./RecordwarningsDetail.vue?vue&type=template&id=53e736ad&scoped=true&"
import script from "./RecordwarningsDetail.vue?vue&type=script&lang=js&"
export * from "./RecordwarningsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e736ad",
  null
  
)

export default component.exports